export const announcementTranslations = {
  coursesNames: 'LingoDaily.courses.names.',
  placesLeft: 'LingoDaily.announcements.placesLeft',
};
